import { CategoryAndTagList } from "components/organisms/CategoryAndTagList";
import { FortuneTellerListItem } from "features/fortune-tellers/components/FortuneTellerListItem";
import { List } from "shared/components/molecules/List";
import { Pager } from "shared/components/molecules/Pager";
import { Loading } from "shared/components/templates/Loading";
import { FortuneTeller } from "shared/types";

interface Props {
  fortuneTellers: FortuneTeller[];
  title?: string;
  description?: string;
  page?: number | string | string[];
  perPage?: number;
  totalPages?: number;
  withRank?: boolean;
  withCategoryList?: boolean;
  loading?: boolean;
}

export const FortuneTellerList = ({
  title,
  description,
  fortuneTellers,
  page,
  perPage,
  totalPages,
  withRank,
  withCategoryList = true,
  loading = true,
}: Props) => {
  return (
    <>
      {loading && <Loading loading={loading} />}
      <div tw="pt-8 px-5 border-t border-solid border-gray mb-[52px]">
        {title && (
          <div tw="flex items-center mb-4">
            <span tw="text-xl mr-2">🔮</span>
            <div tw="flex flex-col">
              <h1 tw="font-semibold text-lg leading-[18px] tracking-[.53px] text-black">
                {title}
              </h1>
              {description && (
                <div tw="font-light text-2xs leading-[14px] text-theme mt-2">
                  {description}
                </div>
              )}
            </div>
          </div>
        )}
        <List
          data={fortuneTellers ?? []}
          columns={2}
          renderItem={(fortuneTeller, index) => (
            <FortuneTellerListItem
              key={fortuneTeller.id}
              fortuneTeller={fortuneTeller}
              ranking={withRank && (Number(page) - 1) * perPage + (index + 1)}
            />
          )}
          bottomBorder={false}
        />
      </div>
      {page && totalPages ? (
        <Pager
          currentPage={Number(page)}
          totalPages={Number(totalPages)}
          tw="mb-[52px]"
        />
      ) : null}
      {withCategoryList && <CategoryAndTagList />}
    </>
  );
};
